
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/migration/migrating-from-jss",
      function () {
        return require("private-next-pages/material-ui/migration/migrating-from-jss.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/migration/migrating-from-jss"])
      });
    }
  